import styled from "styled-components";

export const Container = styled.section`
  width: 100%;
  height: 100%;

  display: grid;
  grid-template: 10% 90% / 100%;
`;
export const ContainerTitulo = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 100% / 1.6% 90%;
  justify-content: center;
  align-items: center;
`;
export const ContainerFiltro = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 100% / 70% 95%;

  justify-content: center;
  align-items: center;
`;
export const ContainerSeta = styled.div`
  width: 100%;
  height: 100%;

  grid-column-start: 1;
  grid-row-start: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ContainerLista = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  min-width: 20rem;
  overflow: auto;
  padding: 1rem;

  grid-template: 10% 90% / auto;
`;

export const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;

export const ContainerAssinatura = styled.div`
  width: 90%;
  height: auto;
  margin-top: 8px;
  border: 2px #858986;
  // background: #f1f1f1;
  // box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
`;
export const TitleAssinatura = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #003644;
  margin-left: 15px;
`;
export const TextAssinatura = styled.p`
  font-size: 14px;
  color: #003644;
  margin-left: 15px;
`;
